module.exports = __webpack_public_path__ + "static/ecwid-a37cb6e00597f30b03e1652cd0c425c7.svg";